import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=02ad6fcc&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=02ad6fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ad6fcc",
  null
  
)

export default component.exports